// extracted by mini-css-extract-plugin
module.exports = {"clickableAlp":"StandaloneAlp_clickableAlp__3CHgf"};